import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Rewind = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Rewind' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='22 3.5 22 20 13 14 13 20 2 12 13 4 13 10' />
  </StyledIcon>
);
